import * as angular from 'angular';
import * as ngCookies from 'angular-cookies';

import 'angular-http-auth';

import commonModule from '../common';
import portalShellModule from 'portal/shell';
import shopNavModule from './nav';
import shopHeaderModule from './header';

export default angular.module('fp:customerportal:shop:shell', [
    ngCookies,

    commonModule.name,
    portalShellModule.name,
    shopNavModule.name,
    shopHeaderModule.name,

    'http-auth-interceptor'
])
    .config(/*@ngInject*/ ($cookiesProvider) => {
        $cookiesProvider.defaults.path = '/';
    })

    .run(/*@ngInject*/($rootScope, $window, $location, $timeout, $log, authService, constants) => {
        $rootScope.$on('event:auth-loginRequired', (event, response) => {
            authService.loginCancelled('Login required', response);

            const url = $window.location.pathname;
            const redirectTo = `${constants.loginHref}?redirectTo=${encodeURIComponent(url)}`;
            $log.debug(`Login Required, redirecting to ${redirectTo}`);
            $timeout(() => {
                $window.location.href = redirectTo;
            });
        });
    });